import { useState } from 'react';
import { Link } from 'react-router-dom';

const FAQS = [
  {
    q: '仕訳数って何ですか？どのプランが合っているか分かりません',
    a: '仕訳数とは、1ヶ月の入出金・売上などの取引件数のことです。年商の目安でプランを選んでいただいても大丈夫です。迷ったら無料相談でお気軽にご相談ください。',
  },
  {
    q: '依頼するには何を準備すればいいですか？',
    a: 'レシート・領収書をまとめてお渡しいただければOKです。紙のままでもスマホ写真でもOK。クラウド会計の初期設定からご一緒に行うことも可能です。',
  },
  {
    q: 'クラウド会計を使ったことがないのですが大丈夫ですか？',
    a: 'まったく問題ありません！一緒にアカウント作成・初期設定から行います。スマホが苦手な方でも丁寧にサポートします。',
  },
  {
    q: 'いつでも解約できますか？',
    a: '最低利用期間などの縛りはありません。1ヶ月前のご連絡でいつでも解約できます。',
  },
  {
    q: 'ホームページ作成も依頼できますか？',
    a: 'はい、サロン向けのホームページ作成も承っております。シンプルな1枚ページから複数ページのサイトまで対応しています。独自ドメイン（専用アドレス）を取得する場合は、年間管理費として¥11,000〜（毎年更新）が別途必要です。詳しくは料金ページをご覧ください。',
  },
  {
    q: 'ホームページの完成までどのくらい時間がかかりますか？',
    a: 'シンプルプランで約1〜2週間、ベーシックプランで2〜4週間が目安です。お写真や原稿のご準備状況によって前後することがあります。お急ぎの場合はお気軽にご相談ください。',
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-14">
          <p className="text-[#0EA5E9] text-sm font-semibold tracking-wider uppercase mb-3">FAQ</p>
          <h2 className="text-3xl font-extrabold text-[#1A2332] mb-3">よくある質問</h2>
          <p className="text-gray-500">ご依頼前の不安を解消します</p>
        </div>

        <div className="space-y-3 mb-10">
          {FAQS.map((faq, i) => (
            <div key={i} className="border border-gray-100 rounded-xl overflow-hidden bg-[#FAFAFA]">
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left cursor-pointer hover:bg-gray-100/60 transition-colors"
              >
                <div className="flex items-start gap-3">
                  <span className="text-[#0EA5E9] font-bold text-sm shrink-0 mt-0.5">Q</span>
                  <span className="text-base font-semibold text-[#1A2332]">{faq.q}</span>
                </div>
                <div className="w-6 h-6 flex items-center justify-center shrink-0">
                  <i className={`ri-${openIndex === i ? 'subtract' : 'add'}-line text-gray-400 text-lg`}></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-6 pb-5 bg-white border-t border-gray-100">
                  <div className="flex gap-3 pt-4">
                    <span className="text-[#1A2332] font-bold text-sm shrink-0">A</span>
                    <p className="text-base text-gray-600 leading-relaxed">{faq.a}</p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/pricing#faq"
            className="inline-flex items-center gap-2 text-[#0EA5E9] font-semibold text-sm hover:gap-4 transition-all duration-300 cursor-pointer"
          >
            <span>もっと詳しいFAQを見る</span>
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
